var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomV2HealthMoon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0158 10.0159C11.8088 8.17264 12.2342 5.39451 11.075 3.09914C11.0045 2.95442 11.0238 2.78202 11.1245 2.65648C11.2253 2.53095 11.3894 2.4748 11.546 2.51234C12.9272 2.84432 14.1899 3.55118 15.195 4.55501C18.2113 7.49315 18.275 12.3201 15.3372 15.3368C12.3207 18.2746 7.49396 18.2114 4.55538 15.1956C3.5517 14.1905 2.84479 12.928 2.51246 11.547C2.47492 11.3905 2.53105 11.2263 2.65659 11.1255C2.78212 11.0248 2.95452 11.0055 3.09924 11.076C5.39464 12.2355 8.17301 11.8096 10.0158 10.0159Z",
    stroke: "#7A7670",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.68255 8.57694L2.67839 8.58111L2.67422 8.57694L2.67839 8.57278L2.68255 8.57694",
    stroke: "#7A7670",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78411 5.88346L3.77995 5.88763L3.77578 5.88346L3.77995 5.8793L3.78411 5.88346",
    stroke: "#7A7670",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83294 3.81645L5.82878 3.82061L5.82461 3.81645L5.82878 3.81228L5.83294 3.81645",
    stroke: "#7A7670",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51654 2.6912L8.51237 2.69537L8.5082 2.6912L8.51237 2.68704L8.51654 2.6912",
    stroke: "#7A7670",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomV2HealthMoon);
export default __webpack_public_path__ + "static/media/customV2HealthMoon.2fce3991813d3a45fab7da9dc5813796.svg";
export { ForwardRef as ReactComponent };